import React from 'react';

export default function Quote(){
  return (
    <section id="quote" className="section quote" data-bg="violet">
      <div className="container" style={{textAlign:'center'}}>
        <span className="badge"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{opacity:.9}}><path d="M12 2l2.39 7.26h7.62l-6.16 4.47 2.35 7.21L12 16.77l-6.2 4.17 2.35-7.21L2 9.26h7.61L12 2z" fill="currentColor"/></svg> Prompt chaos is slowing the AI adoption</span>
        <p style={{fontSize:'1.8rem',lineHeight:1.4,fontWeight:500,margin:'22px 0 0'}}>Turn prompt <em className="quote-chaos">chaos</em> into <span className="quote-clarity">clarity</span>. Manage prompts,<br/>agents, and workflows in one professional platform.</p>
      </div>
    </section>
  );
}
